import paperPlane from "@assets/images/paper-plane.png";
import { Button, Paper } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
const useStyles = makeStyles(
  () => ({
    root: {
      width: "360px",
      padding: "32px 24px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      margin: "0 auto",
      marginTop: "260px",
      borderRadius: "1.6rem",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      "& .MuiButton-root": {
        width: "100%",
        marginTop: "4rem"
      },
      "& .MuiTypography-root": {
        marginTop: "4rem",
        background:
          "linear-gradient(90deg, #007E92 0%, #009FB8 50.13%, #00B9A3 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        textFillColor: "transparent"
      }
    }
  }),
  { name: "CreateOrderSuccess" }
);

interface CreateOrderSuccessProps {
  onReset: () => void;
}

const CreateOrderSuccess: React.FC<CreateOrderSuccessProps> = ({ onReset }) => {
  const classes = useStyles();
  return (
    <Paper className={classes.root}>
      <img src={paperPlane} alt="paper-plane-icon" />
      <MyTypography variant="h6">ส่งคำสั่งซื้อสำเร็จแล้ว</MyTypography>
      <Button color="secondary" variant="contained" onClick={onReset}>
        กลับไปหน้าแรก
      </Button>
    </Paper>
  );
};

export default CreateOrderSuccess;
